import { useIsLoading } from 'affiny-core/hooks';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { Flex, Text, theme } from 'affiny-ui/src';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

export interface IProfileCaptureLayout {
  children: ReactNode;
}

export const ProfileCaptureLayout = ({ children }: IProfileCaptureLayout) => {
  const { t } = useTranslation();

  const isLoading = useIsLoading(EAsyncEventTypes.GET_MEMBER_CHOICES);

  if (isLoading) {
    return (
      <Flex
        minHeight="100vh"
        justifyContent="center"
        alignItems="center"
        background={theme.colors.gradientProfileCapture}
      >
        <SBlinkText color="light">{t('profileCapture.loading')}</SBlinkText>
      </Flex>
    );
  }

  return <>{children}</>;
};

const blink = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;

const SBlinkText = styled(Text)`
  animation: ${blink} 1s infinite;
`;
